// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WCCOsBTWm3jq8AWdkzup{width:100%;align-self:stretch}", "",{"version":3,"sources":["webpack://./src/code-studio/components/project-abuse-alert.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,kBAAA","sourcesContent":[".alert {\n  width: 100%;\n  align-self: stretch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": "WCCOsBTWm3jq8AWdkzup"
};
export default ___CSS_LOADER_EXPORT___;
